import { createSelector } from 'reselect'
import { pendingSelector } from 'api/selectors'

export const headerStateSelector = state => state.header || {}

export const isAuthVisibleSelector = createSelector(headerStateSelector, header => header.isAuthVisible)

export const authActiveFormSelector = createSelector(headerStateSelector, header => header.activeForm)

export const isAuthPendingSelector = createSelector(
    pendingSelector,
    pending => pending.login || pending.restoreUserSession
)
